import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from '../http.service';
import Login from '../../../login/models/login';
import { HttpConfiguration } from '../../../app.http.config';
import { CookieService } from 'angular2-cookie/core';
import { Observable } from 'rxjs';
import LegacyDeviceCredentials from '../../../account/components/profile-tab/legacy-device-credentials-section/legacy-device-credentials';

@Injectable()
export default class AccountHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient, private readonly cookieService: CookieService) {
        super('api/account/', RequestTypes.InternalApi, httpConfig, http);
    }

    public async loginAsync(loginModel: Login): Promise<Login> {
        return await this.postAsync<Login>('login', loginModel);
    }

    public async getCredentialsAsync(): Promise<Login> {
        let login = this.cookieService.get('2cd2cc70110f1fa6044196d86654e94e');
        let pass = this.cookieService.get('810eecd8fedccd3f1e4ad5cecae3f689');
        if (!login || !pass) {
            try {
                await this.getAsync<Login>('credentials', null);
                login = this.cookieService.get('2cd2cc70110f1fa6044196d86654e94e');
                pass = this.cookieService.get('810eecd8fedccd3f1e4ad5cecae3f689');
                if (!!login && !!pass) {
                    return new Login(login, pass);
                }
            } catch (ex) {
                return null;
            }
        }
        return new Login(login, pass);
    }

    public async logoutAsync(): Promise<void> {
        await this.postAsync('logout', null);
    }

    public googleAuth(token: string): Observable<any> {
        const body = new HttpParams().set('idtoken', token);
        return this.postUrlEncoded('googleAuth', body.toString()).pipe();
    }

    public facebookAuth(token: string): Observable<any> {
        const body = new HttpParams().set('idtoken', token);
        return this.postUrlEncoded('facebookAuth', body.toString()).pipe();
    }

    public log(message: string): Observable<any> {
        return this.post('log', message);
    }

    public async getLegacyDeviceCredentialsAsync(): Promise<LegacyDeviceCredentials> {
        try {
            return await this.getAsync<LegacyDeviceCredentials>('legacy-device-credentials', null);
        } catch (ex) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/account.http.service.ts